import MyFpuComponentViewInterface from "@app/Interface/MyFpuComponentViewInterface";
import ProducerInterface from "@app/Interface/ProducerInterface";
import MyFpuComponentType from "@app/Type/MyFpuComponentType";
import ProducerModel from "./ProducerModel";

export default class MyFpuComponentViewModel implements MyFpuComponentViewInterface {
    fpuId: number;
    producer: ProducerInterface;
    component: MyFpuComponentType;

    constructor() {
        this.fpuId = 0;
        this.producer = new ProducerModel();
        this.component = "MyFpuListPage";
    }
    
}